import React from 'react';
import { Link } from 'react-router-dom';

import '../../home/home.css';

const Solution = () => {

    return(
        <>
            <section className="insidePage" style={{ backgroundColor: '#2fb8e7' }}>
                <div className="container" data-aos="fade-up" data-aos-duration="500" data-aos-delay="0.9s">
                    <p className="text-white">
                        <span className='title text-center'>Solution</span> 
                        <span className='text-center subTitle'>
                            Trusted by big one and loved by everyone
                        </span>
                    </p>            
                </div>
            </section>

            <main className="main">
                <section id="clients" className="clients">
                    <div className="container" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="0.9s">
                        <div className="row gy-4">
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/ecommerce-solution'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/solution/eCommerce/web_solution_firm_ecommerce-single-vendor.webp" alt="" />
                                    </div> 
                                    <h5>eCommerce Solution</h5>
                                    <p>Our eCommerce solution has the features to boost your online growth...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/edtech'>
                                    <div className="img mb-3">
                                        <img src="assets/img/solution/edTech/web_solution_firm_lms.webp" alt="" />
                                    </div> 
                                    <h5>EdTech Solution</h5>
                                    <p>All in-one system for learning, growth, skills, management...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/small-to-medium-business'>
                                    <div className="img mb-3">
                                        <img src="assets/img/about.jpg" alt="" />
                                    </div> 
                                    <h5>Small to Medium Business</h5>
                                    <p>Cloud-based web application keeps track of all the sales, purchase, bill...</p>
                                </Link>
                            </div>
                            <div className="col-lg-3 solution-cards-body" >
                                <Link to = '/corporate'>
                                    <div className="img mb-3">
                                        <img src="../../assets/img/solution/BusinessTransformation.jpg" alt="" />
                                    </div> 
                                    <h5>Corporate Solution</h5>
                                    <p>Manage your office and meeting room smartly from anywhere & anytime…</p>
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </>
    ); 
}
export default Solution;